import React from 'react';

const ProgressBar = ({ 
  value, 
  max = 100, 
  className = '',
  showPercentage = false,
  size = 'medium',
  color = 'blue'
}) => {
  const percentage = Math.min((value / max) * 100, 100);
  
  const sizes = {
    small: 'h-2',
    medium: 'h-3',
    large: 'h-4'
  };
  
  const colors = {
    blue: 'from-blue-500 to-blue-600',
    green: 'from-green-500 to-green-600',
    purple: 'from-purple-500 to-purple-600',
    red: 'from-red-500 to-red-600',
    yellow: 'from-yellow-500 to-yellow-600'
  };

  return (
    <div className={`w-full ${className}`}>
      <div className={`progress-bar ${sizes[size]}`}>
        <div 
          className={`progress-fill bg-gradient-to-r ${colors[color]}`}
          style={{ width: `${percentage}%` }}
        />
      </div>
      {showPercentage && (
        <div className="text-sm text-gray-600 mt-1 text-right">
          {Math.round(percentage)}%
        </div>
      )}
    </div>
  );
};

export default ProgressBar;
